module.exports = __webpack_public_path__ + "img/3.3ebbff1f.jpg";